
export default[
    //周会议列表
    {
        path: '/agent/weekMeeting',
        component: () => import( '@/views/loud/agent/weekMeeting/weekMeetingList.vue'),
        meta: {
            keepAlive:true,
            title: '周清会议列表',
            isTabsPage: true
        }
    },
    //新增周会议
    {
        path: '/agent/addWeekMeeting',
        component: () => import( '@/views/loud/agent/weekMeeting/addWeekMeeting.vue'),
    },
    //查看周会议
    {
        path: '/agent/seeWeekMeeting',
        component: () => import( '@/views/loud/agent/weekMeeting/seeWeekMeeting.vue'),
    },
    //修改周会议
    {
        path: '/agent/changeWeekMeeting',
        component: () => import( '@/views/loud/agent/weekMeeting/changeWeekMeeting.vue'),
    },

    //签约经销商周清会控制台账
    {
        path: '/agent/weekMeetingAccount',
        component: () => import( '@/views/loud/agent/weekMeeting/weekMeetingAccountList.vue'),
        meta: {
            keepAlive:true,
            title: '签约经销商周清会控制台账',
            isTabsPage: true
        }
    },


    //运营会列表--新
    {
        path: '/agent/weeklyMeetingList',
        component: () => import( '@/views/loud/agent/weeklyMeeting/weeklyMeetingList.vue'),
        meta: {
            title: '网络运营会列表',
            isTabsPage: true,
            keepAlive:true,
        }
    },
    //新增运营会---新
    {
        path: '/agent/addWeeklyMeeting',
        component: () => import( '@/views/loud/agent/weeklyMeeting/addWeeklyMeeting.vue'),
    },
    //修改运营会
    {
        path: '/agent/changeWeeklyMeeting',
        component: () => import( '@/views/loud/agent/weeklyMeeting/changeWeeklyMeeting.vue'),
    },
    //查看运营会
    {
        path: '/agent/seeWeeklyMeeting',
        component: () => import( '@/views/loud/agent/weeklyMeeting/seeWeeklyMeeting.vue'),
    },
    //周清会议新增时用户
    {
        path: '/agent/battleNetUserNeedDel',
        component: () => import( '@/views/loud/agent/weeklyMeeting/battleNetUserNeedDel.vue'),
        meta: {
            title: '未覆盖用户计划',
            isTabsPage: true,
            keepAlive:true
        }
    },

    //经销商季度会议报表
    {
        path: '/agent/marketingReport',
        component: () => import( '@/views/loud/agent/marketingReport.vue'),
        meta: {
            title: '市场推广活动季度报表',
            isTabsPage: true,
        }
    },

    //经销商季度会议报表Tabs页
    {
        path: '/agent/marketingReportTabs',
        component: () => import( '@/views/loud/agent/marketingReportTabs.vue'),
        meta: {
            title: '市场推广活动季度报表',
            isTabsPage: true,
        }
    },

    //经销商季度会议报表朗康
    {
        path: '/agent/marketingReportLk',
        component: () => import( '@/views/loud/agent/marketingReportLk.vue'),
        meta: {
            title: '市场推广活动季度报表(朗康)',
            isTabsPage: true,
        }
    },

    //经销商季度会议报表朗康
    {
        path: '/agent/marketingReportLkAdd',
        component: () => import( '@/views/loud/agent/marketingReportLkAdd.vue'),
        meta: {
            title: '市场推广活动季度报表(朗康)',
            isTabsPage: true,
        }
    },


    //新增运营会---------------------------------------2026---------------------------------

    {
        path: '/agent/weekMeetingTabs',
        component: () => import( '@/views/loud/agent/weeklyMeeting/weekMeetingTabs.vue'),
    },


    {
        path: '/agent/addWeeklyMeeting2026',
        component: () => import( '@/views/loud/agent/weeklyMeeting/addWeeklyMeeting2026.vue'),
    },

    {
        path: '/agent/seeWeeklyMeeting2026',
        component: () => import( '@/views/loud/agent/weeklyMeeting/seeWeeklyMeeting2026.vue'),
    },
]
